"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Source = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _generateImageSizes = _interopRequireDefault(require("../../functions/generateImageSizes"));

var _generateUrlParams = _interopRequireDefault(require("../../functions/generateUrlParams"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
} // Component


var Source =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Source, _PureComponent);

  function Source() {
    _classCallCheck(this, Source);

    return _possibleConstructorReturn(this, _getPrototypeOf(Source).apply(this, arguments));
  }

  _createClass(Source, [{
    key: "generateQuality",
    value: function generateQuality() {
      var quality = this.props.quality;
      return "q=".concat(quality);
    }
  }, {
    key: "generateSizes",
    value: function generateSizes() {
      var maxWidth = this.props.maxWidth;
      return (0, _generateImageSizes.default)(maxWidth);
    }
  }, {
    key: "generateParams",
    value: function generateParams() {
      var params = this.props.params;
      return (0, _generateUrlParams.default)(params);
    } // generateBaseSrc() applies compression but should not apply any resizing

  }, {
    key: "generateBaseSrc",
    value: function generateBaseSrc() {
      // extract props
      var src = this.props.src; // generate any needed settings

      var format = 'auto=format';
      var params = this.generateParams();
      var quality = this.generateQuality(); // build and return url

      return "".concat(src, "?").concat(format).concat(params !== '' ? "&".concat(params) : '', "&").concat(quality);
    }
  }, {
    key: "generateSrcSet",
    value: function generateSrcSet() {
      var _this = this; // extract props


      return this.generateSizes().map(function (size) {
        return "".concat(_this.generateBaseSrc(), "&fit=clip&w=").concat(size, " ").concat(size, "w");
      }).join(', ');
    }
  }, {
    key: "generateMedia",
    value: function generateMedia() {
      var displayBelow = this.props.displayBelow;
      return "(max-width: ".concat(displayBelow, "px)");
    }
  }, {
    key: "render",
    value: function render() {
      // render
      return _react.default.createElement("source", {
        srcSet: this.generateSrcSet(),
        media: this.generateMedia()
      });
    }
  }]);

  return Source;
}(_react.PureComponent);

exports.Source = Source;
Source.displayName = 'Source';
Source.propTypes = {
  displayBelow: _propTypes.default.number.isRequired,
  params: _propTypes.default.array,
  quality: function quality(props, propName) {
    // get quality
    var quality = props[propName]; // check if quality is not a number

    if (typeof quality !== 'number') {
      return new Error("The prop 'quality' must be an INTEGER. You passed in \n         a ".concat(_typeof(quality).toUpperCase(), "."));
    } // check if quality is a decimal


    if (parseInt(Number(quality), 10) !== quality) {
      return new Error("The prop 'quality' must be an INTEGER not a DECIMAL. Did you \n         mean '".concat(Math.round(quality), "' instead of '").concat(quality, "'."));
    } // check if quality is greater than 100 or less than 0


    if (quality > 100 || quality < 0) {
      return new Error("The prop 'quality' must be between '0' and 100'. You \n         passed in '".concat(quality, "'."));
    }
  }
};
Source.defaultProps = {
  params: [],
  quality: 70
};